import PropTypes from 'prop-types';
import { serviceHelper } from '../../../config/service-helper';
import { getStoreCountryName } from '../../../../scripts/utils/multiTenancyHeaders';

export const ADDRESS_PROPTYPES = {
  id: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  company: PropTypes.string,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string,
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  province: PropTypes.string.isRequired,
  provinceCode: PropTypes.string.isRequired,
  default: PropTypes.bool.isRequired,
};

export const EMPTY_ADDRESS = {
  default: false,
  id: 0,
  company: '',
  firstName: '',
  lastName: '',
  country: getStoreCountryName(),
  province: window.Jbhifi?.storeLocation === 'NZ' ? 'Auckland' : 'Australian Capital Territory',
  provinceCode: window.Jbhifi?.storeLocation === 'NZ' ? 'AUK' : 'ACT',
  city: '',
  zip: '',
  address1: '',
  address2: '',
  phone: '',
};

export const B2C_URLS = {
  changeDetails: `${serviceHelper.b2cBaseUrl}${serviceHelper.b2cPathDetailsChange}`,
  linkSocial: `${serviceHelper.b2cBaseUrl}${serviceHelper.b2cPathSocialLink}`,
  unlinkSocial: `${serviceHelper.b2cBaseUrl}${serviceHelper.b2cPathSocialUnlink}`,
  changePassword: `${serviceHelper.b2cBaseUrl}${serviceHelper.b2cPathPasswordUpdate}`,
  loginCreate: `${serviceHelper.b2cBaseUrl}${serviceHelper.b2cPathLoginCreate}`,
  logout: `${serviceHelper.b2cBaseUrl}${serviceHelper.b2cPathLogout}`,
};

export const MONTH_ARRAY = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const CUSTOMER_PREFERENCE_KEYS = {
  skipSetBirthday: 'shopify_perks_skipSetBirthday',
  skipSetBirthdayMobile: 'shopify_account_skipMobileVerification',
  skipPerksSignup: 'perks_skipJoinPrompt',
};

export const DEFAULT_BIRTHDAY_MESSAGE = 'Tell us your birthday month for a Birthday Perk!';
export const BIRTH_MONTH_DESCRIPTION = 'Get a special treat for your birthday.';

export const ALLOW_SPACES_FOR_KEY = {
  firstName: true,
  lastName: false,
};
